import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {HiOutlineMenu} from '@react-icons/all-files/hi/HiOutlineMenu';
import {HiOutlineX} from '@react-icons/all-files/hi/HiOutlineX';
import IconButton from '@material-ui/core/IconButton';
import classnames from 'classnames';
import Logo from '../Logo/Logo';
import ThemeSelector from '../Header/ThemeSelector/ThemeSelector';
import {useCeremonyRoute} from '@hooks/useCeremonyRoute';
import {
    selectIsLeftMenuOpen,
    setIsLeftMenuOpen
} from '../../SignerUi/signerUiSlice';
import './signerUiHeader.less';

export default function SignerUiHeader() {
    const dispatch = useDispatch();
    const isMenuOpen = useSelector(selectIsLeftMenuOpen);
    const ceremonyRoute = useCeremonyRoute();
    const isLeftMenuVisible = ceremonyRoute?.isLeftMenuVisible !== false;
    const className = classnames('header');

    const canShowLogo = true;

    function toggleMenu() {
        dispatch(setIsLeftMenuOpen(!isMenuOpen));
    }

    return (
        <div className="signer-ui-header-container">
            <div className={className}>
                {isLeftMenuVisible && (
                    <IconButton
                        classes={{root: 'signing-menu-toggle-icon'}}
                        data-wdio="test-signer-ui-menu-btn"
                        onClick={toggleMenu}
                    >
                        {isMenuOpen
                            ? <HiOutlineX className="icon" />
                            : <HiOutlineMenu className="icon" />}
                    </IconButton>
                )}
                {canShowLogo && <Logo isSignerUI isRedirectDisabled />}
                <div className="right-container">
                    <ThemeSelector />
                </div>
            </div>
        </div>
    );
}
